import React, {Component} from 'react';
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";


class ActivePassiveCellRender extends Component {

  render() {
    return (
       this.props.value ? <span className={"badge bg-success"}>{this.props.t('Active')}</span>:<span className={"badge bg-danger"}>{this.props.t('Passive')}</span>
    )
  }
}

ActivePassiveCellRender.propTypes = {
  value: PropTypes.any,
  t: PropTypes.any,
};

export default (withTranslation()(ActivePassiveCellRender));